import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import Moment from 'moment';
import 'moment/locale/pt-br';
import { endpointState } from '../../recoil/atoms';

import BitPage from '../../components/BitPage/BitPage';
import BitHeaderFull from '../../components/BitHeader/BitHeaderFull';
import BitLinkButton from '../../components/BitLinkButton/BitLinkButton';
import BitTable from '../../components/BitTable/BitTable';
import BitInput from '../../components/BitInput/BitInput';

interface interfaceEmpreendimentos {
	value: {
		value: string | number;
		label: string;
		selected: boolean;
	}[];
	required: boolean;
}

const WhatsAppList: React.FC = () => {
	const { urlEndpoint } = useRecoilValue(endpointState);
	const token = localStorage.getItem('token');

	const [empreendimentos, setEmpreendimentos] = useState<interfaceEmpreendimentos>({
		value: [],
		required: false,
	});
	const [selectedDevelopment, setSelectedDevelopment] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const [tableData, setTableData] = useState<{ headers: string[]; data: any[] }>({
		headers: ['Título da Publicação', 'Mensagem', 'Empreendimento', 'Data de Envio', 'Status'],
		data: [],
	});

	// Carregar Empreendimentos para o filtro
	useEffect(() => {
		axios
			.get(`${urlEndpoint}/developments`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(response => {
				const fetchedData = response.data?.data?.data || response.data?.data || [];
				const allEmpreendimentos = Array.isArray(fetchedData) ? fetchedData : [fetchedData];

				const newValueEmpreendimentos: {
					value: string | number;
					label: string;
					selected: boolean;
				}[] = [
					{
						value: '',
						label: 'Todos os empreendimentos',
						selected: true,
					},
				];

				allEmpreendimentos.forEach((emp: any) => {
					newValueEmpreendimentos.push({
						value: emp.id,
						label: emp.name,
						selected: false,
					});
				});

				setEmpreendimentos({
					value: newValueEmpreendimentos,
					required: false,
				});
			})
			.catch(err => {
				console.error('Erro ao carregar empreendimentos no filtro:', err);
			});
	}, [urlEndpoint, token]);

	// Buscar histórico de envios do WhatsApp
	const fetchWhatsappPublications = (devId?: string) => {
		setLoading(true);
		const params: any = {};
		if (devId) {
			params.development_id = devId;
		}

		axios
			.get(`${urlEndpoint}/whatsapp-publications/`, {
				params,
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(response => {
				setLoading(false);
				const rawList = response.data?.data?.data || response.data?.data || response.data;
				const list = Array.isArray(rawList) ? rawList : [];

				const formattedRows = list.map((item: any) => ({
					titulo: item.publication?.title || (item.publication_id ? `Publicação #${item.publication_id}` : '-'),
					mensagem: item.wa_text || '-',
					empreendimento: item.development?.name || (item.development_id ? `Empreendimento #${item.development_id}` : '-'),
					data: item.created_at ? Moment(item.created_at).format('DD/MM/YYYY HH:mm') : '-',
					status: item.status === 'success' ? 'Sucesso' : item.status || 'Enviado',
				}));

				setTableData({
					headers: ['Título da Publicação', 'Mensagem', 'Empreendimento', 'Data de Envio', 'Status'],
					data: formattedRows,
				});
			})
			.catch(err => {
				setLoading(false);
				console.error('Erro ao buscar whatsapp-publications:', err);
				setTableData({
					headers: ['Título da Publicação', 'Mensagem', 'Empreendimento', 'Data de Envio', 'Status'],
					data: [],
				});
			});
	};

	useEffect(() => {
		fetchWhatsappPublications(selectedDevelopment);
	}, [selectedDevelopment, urlEndpoint, token]);

	const handleSelectDevelopment = (e: React.FormEvent<HTMLSelectElement>) => {
		const targetValue = e.currentTarget.value;
		setSelectedDevelopment(targetValue);

		const updatedValue = empreendimentos.value.map(emp => ({
			...emp,
			selected: String(emp.value) === String(targetValue),
		}));
		setEmpreendimentos({
			value: updatedValue,
			required: false,
		});
	};

	return (
		<BitPage>
			<BitHeaderFull
				label="Comunidade / Histórico de Envios"
				icon="fab fa-whatsapp"
				hasIcon={true}
			/>

			<div className="p-5 mb-4 bg-white rounded">
				<div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
					<h2 className="text-2xl font-semibold flex items-center">
						<i className="fab fa-whatsapp text-bgGreen mr-3 text-3xl" />
						Mensagens Enviadas (WhatsApp)
					</h2>
					<BitLinkButton
						link="/whatsapp/enviar"
						text="Enviar Mensagem"
						buttonColor="#3AABA2"
						textColor="#FFFFFF"
					/>
				</div>

				<div className="mb-6 max-w-sm">
					<BitInput
						label="Filtrar por Empreendimento"
						type="select"
						multipleSelect={false}
						placeholder="Todos os empreendimentos..."
						valuesSelect={empreendimentos.value}
						classField="grupo-campo-novos-registros"
						onChange={handleSelectDevelopment}
					/>
				</div>

				{loading ? (
					<div className="py-12 flex items-center justify-center text-gray-500">
						<i className="fas fa-spinner fa-spin mr-2 text-2xl" />
						Carregando histórico de envios do WhatsApp...
					</div>
				) : (
					<BitTable
						tableData={tableData}
						noneMessage="Nenhuma mensagem enviada encontrada."
					/>
				)}
			</div>
		</BitPage>
	);
};

export default WhatsAppList;
